import React from 'react';
export const Nav = props => {
    return (
        <nav
            className='nav'
        >
            {props.children}
            <ul id='menu-items' className='menu-items'>
                <li className='about-menu-item menu-item'>
                    <a
                        href='#about-section'
                        className='nav-link about-btn--open btn-ripple'
                        onClick={props.toggleOverlay}
                        aria-expanded={props.overlayType === "about" ? "true" : "false"}
                    >
                        <div className='ripple'></div>
                        About
                    </a>
                    {props.windowSize < 600 ? (
                        <i
                            className='fas fa-long-arrow-alt-right about-btn--open-arrow'
                            aria-hidden='true'></i>
                    ) : (
                        ""
                    )}
                </li>
                <li className='menu-item'>
                    <a
                        href='#skills-section'
                        className='nav-link btn-ripple'
                        onClick={props.toggleOverlay}
                    >
                        <div className='ripple'></div>
                        Skills
                    </a>
                </li>
                <li className='menu-item'>
                    <a
                        href='#projects-section'
                        className='nav-link btn-ripple'
                        onClick={props.toggleOverlay}
                    >
                        <div className='ripple'></div>
                        Projects
                    </a>
                </li>
                <li className='menu-item'>
                    <a
                        href='#contact-section'
                        className='nav-link btn-ripple'
                        onClick={props.toggleOverlay}
                    >
                        <div className='ripple'></div>
                        Contact
                    </a>
                </li>
            </ul>
        </nav>
    );
};
